import type { ItemVariation } from '@kimuno/api-sdk/lib/types/responses/Collection';
import immutable from 'object-path-immutable';

import { LOGOUT, type LogoutAction } from '../actions/auth.actionTypes';
import { AsyncActionStatus } from '../actions/common.actionTypes';
import {
	FETCH_RECENTLY_VIEWED,
	type FetchRecentlyViewedAction,
} from '../actions/recentlyViewed.actionTypes';

type RecentlyViewedActionTypes = FetchRecentlyViewedAction | LogoutAction;

type RecentlyViewedContent = { id: string; type: ItemVariation };
export type RecentlyViewedContentArray = Array<RecentlyViewedContent>;

export interface RecentlyViewedInitialStateType {
	contents: RecentlyViewedContentArray;
	error: null | string;
	status: AsyncActionStatus;
}

const initialState: RecentlyViewedInitialStateType = {
	contents: [],
	error: null,
	status: AsyncActionStatus.LOADING,
};

const recentlyViewed = (
	// biome-ignore lint/style/useDefaultParameterLast: parameter order is a fixed contract (Redux reducer signature / existing call sites)
	state = initialState,
	action: RecentlyViewedActionTypes
): RecentlyViewedInitialStateType => {
	switch (action.type) {
		case LOGOUT.SUCCESS:
			return initialState;

		case FETCH_RECENTLY_VIEWED.START:
			return immutable(state).set('status', AsyncActionStatus.LOADING).set('error', null).value();

		case FETCH_RECENTLY_VIEWED.ERROR:
			return immutable(state)
				.set('status', AsyncActionStatus.ERROR)
				.set('error', action.error.message)
				.value();

		case FETCH_RECENTLY_VIEWED.SUCCESS:
			// The endpoint returns the newest-first, deduplicated, access-filtered
			// list — store it as-is (read-only row, no client-side mutations).
			return immutable(state)
				.set(
					'contents',
					action.result.data.map((r) => ({ id: r.id, type: r.type }))
				)
				.set('status', AsyncActionStatus.READY)
				.value();
	}

	return state;
};

export default recentlyViewed;
